import { Component, OnInit, Input, OnDestroy } from '@angular/core';
import { BehaviorSubject, Subscription } from 'rxjs';
import { Journal, Author } from 'src/app/shared/models/user';

@Component({
  selector: 'app-profile-journal',
  templateUrl: './profile-journal.component.html',
  styleUrls: ['./profile-journal.component.scss']
})
export class ProfileJournalComponent implements OnInit, OnDestroy {
  @Input() journals = new BehaviorSubject<Journal[]>([]);

  // what the UI should render + paginate
  readonly journalsView = new BehaviorSubject<Journal[]>([]);

  private sub?: Subscription;
  private all: Journal[] = [];

  yearOrder: number = 2;
  searchField: string = '';
  page = 1;
  pageSize = 10;

  ngOnInit(): void {
    this.sub = this.journals.subscribe(list => {
      this.all = list ?? [];
      this.applyFilter();
    });
  }

  ngOnDestroy(): void {
    this.sub?.unsubscribe();
  }

  onSearchChange(val: string): void {
    this.searchField = val ?? '';
    this.page = 1;
    this.applyFilter();
  }

  private applyFilter(): void {
    const needle = this.searchField.trim().toLowerCase();

    if (!needle) {
      this.journalsView.next(this.all);
      return;
    }

    const filtered = this.all.filter(j => {
      // some titles may have html tags or be null
      const titleRaw = j?.title ?? '';
      const titlePlain = this.stripHtml(titleRaw).toLowerCase();
      return titlePlain.includes(needle);
    });

    this.journalsView.next(filtered);
  }

  private stripHtml(value: string): string {
    // removes tags like <i>...</i>; keeps text for searching
    return (value ?? '').replace(/<[^>]*>/g, '');
  }

  formatAuthorName(author: Author): string {
    const mi = author?.middleInitial?.trim();
    return mi ? `${author.firstName}, ${author.lastName} ${mi}` : `${author.firstName}, ${author.lastName}`;
  }
}